import React from 'react';
import { DropDown } from './common';
import { DuLieuHeThong } from 'api';
import { validatable } from 'components/utils';

class DropDownChonPhoPhong extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      allData: []
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    if (this.props.phongBanId)
      this.loadData(this.props.phongBanId);
  }

  loadData(phongBanId) {
    DuLieuHeThong.actions.getChuyenVienThuocPhongBan.request({ coQuanQuanLyId: phongBanId, vaiTro: this.props.vaiTro, isPhoPhong: true }).then(res => {
      if (typeof res.data._embedded != "undefined") {

        this.setState({
          data: res.data._embedded.congChucs
        })
      } else {
        this.setState({
          data: []
        })
      }
    }).catch(err => {})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.phongBanId != nextProps.phongBanId) {
      if (nextProps.phongBanId) {
        if (typeof this.state.allData[nextProps.phongBanId] != "undefined") {
          this.setState({
            data: this.props.data[nextProps.phongBanId]
          });
        } else {
          this.loadData(nextProps.phongBanId);
        }
      } else {
        this.setState({
          data: []
        });
      }
    }
  }

  render() {
    return (
      <DropDown
        bindValidator={this}
        channel="formTaoDon"
        isValid={this.props.isValid}
        require={this.props.require}
        label={this.props.label}
        className={this.props.className}
        options={this.state.data}
        keyName='congChucId'
        valueName='hoVaTen'
        onChange={this.onChange.bind(this)}
        placeholder={this.props.placeholder}
        selectedValue={this.props.selectedValue}
        name={this.props.name}/>
    )
  }
}

DropDownChonPhoPhong.defaultProps = {
  label: 'Công chức xử lý',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name:''
}

export default validatable(DropDownChonPhoPhong);



// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonPhoPhong.jsx